export enum FrontendQuestionType {
  ImageChoice = 'ImageChoice',
  Url = 'Url',
  MobileApp = 'MobileApp',
  NameEmail = 'NameEmail',
  MatrixRating = 'MatrixRating',
}

export enum FrontendProjectType {
  Form = 'Form',
}
